var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"AdminMenuList"}},[_c('v-list',_vm._l((_vm.admin_navigation),function(item,index){return _c('admin-menu-list-item',{key:("admin-menu-child-item-" + index),attrs:{"item":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }